(function () {
    'use strict';

    var capitalizeNonNumber = {
        controller: capitalizeNonNumberController,
        controllerAs: 'vm',
        bindings: {
            ngModel: "="
        }
    }

    angular
        .module('completeAir')
        .component('capitalizeNonNumber', capitalizeNonNumber)

    capitalizeNonNumberController.$inject = ['$element'];

    function capitalizeNonNumberController($element) {
        var vm = this;
        var input = $element.parent(),
            inputJQ = input.find('.form-control');

        vm.value = "";

        inputJQ.on('keyup', function () {
            var ele = $(this),
                val = ele.val();

            if (vm.isValidString(val)) {
                var stringArr = val.split(" ");
                var result = "";
                var cap = stringArr.length;
                for (var x = 0; x < cap; x++) {
                    stringArr[x].toLowerCase();
                    if (x === cap - 1) {
                        result += stringArr[x].substring(0, 1).toUpperCase() + stringArr[x].substring(1);
                    } else {
                        result += stringArr[x].substring(0, 1).toUpperCase() + stringArr[x].substring(1) + " ";
                    }
                    vm.ngModel = result;
                }
            } else {
                vm.ngModel = '';
            }
        });

        vm.replaceAllSpecialCharacters = function (str) {
            return str.replace(/0123456789[&\/\\#,+()$~%.'":*?<>{}]/g, "");
        }

        vm.isValidString = function (str) {
            var iChars = "0123456789~`!#$%^&*+=-[]\\\';,/{}|\":<>?";
            if (str) {
                for (var i = 0; i < str.length; i++) {
                    if (iChars.indexOf(str.charAt(i)) != -1) {
                        return false;
                    }
                }
            }
            return true;
        }

    }
})();

